import script from "./TopText.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopText.vue?vue&type=script&lang=ts&setup=true"

import "./TopText.vue?vue&type=style&index=0&id=7bcb5d00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bcb5d00"]])

export default __exports__